// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"wZ-z","subtitle":"xZ-z","wrapper":"yZ-z","leftArrow":"zZ-z","rightArrow":"AZ-z"};